import { produce } from "immer";
import {
  GET_REVISIONS,
  GET_REVISIONS_SUCCESS,
  GET_REVISIONS_FAILURE,
  SET_REVISION_STEP,
  SET_REVISION_FIELDS,
} from "./constants";

export const initialState = {
  revisions: [],
  isFetchingRevisions: false,
  revisionStep: null,
  revisionFields: [],
};

const OnboardingRevisionReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case GET_REVISIONS:
        draft.isFetchingRevisions = true;
        break;
      case GET_REVISIONS_SUCCESS:
        draft.revisions = action.payload;
        draft.isFetchingRevisions = false;
        break;
      case GET_REVISIONS_FAILURE:
        draft.isFetchingRevisions = false;
        break;
      case SET_REVISION_STEP:
        draft.revisionStep = action.payload;
        break;
      case SET_REVISION_FIELDS:
        draft.revisionFields = action.payload;
        break;
      default:
        return state;
    }
  });

export default OnboardingRevisionReducer;
